import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IUI_Settings, IUI_SettingsTable, TUISettingsCodes } from '../../../../../models/index.db..model';
import { Contract_Table_Default_Settings } from '../contract-table-const';
import { UIsettingsService } from '../../../../../services/ui-settings.service';

@Component({
    selector: 'app-ui-settings-ct-form',
    templateUrl: './ui-settings-ct-form.component.html',
    styleUrl: './ui-settings-ct-form.component.scss'
})
export class AppUISettingsCTFormComponent {
  private code:TUISettingsCodes = 'contractTableInstance'
  public user_guid:string = ''
  public defaultSettings = Contract_Table_Default_Settings
  public tableSettings: FormGroup|undefined = undefined
  public settingsLabels = new Map <string,string>([
    ['table_code','Код таблицы'],
    ['fields','Основные поля'],
    ['custom_fields','Дополнительные поля'],
    //['rows_qty_to_cache', 'Предзагрузка кол-во строк'],
    ['sort_default', 'Сортировка'],
   // ['page_rows_qty','Строк на одной странице'] 
  ])

	constructor(
    private fb: FormBuilder,

    private uiSettingsService:UIsettingsService,
		private dialogRef: MatDialogRef<AppUISettingsCTFormComponent>,
	) {
	}
	ngOnInit(): void {
		this.uiSettingsService.getUISettings(this.user_guid).subscribe(settings=>{
      let currentSettings = settings?.tables?.find(el=>el.table_code === this.code) || Contract_Table_Default_Settings
      this.tableSettings = this.fb.group({
          page_rows_qty: [currentSettings?.page_rows_qty || this.defaultSettings.page_rows_qty, {validators: []}],
          rows_qty_to_cache: [currentSettings?.rows_qty_to_cache || this.defaultSettings.rows_qty_to_cache, {validators: []}],
          table_code:{value: this.code, disabled: true},
          custom_fields:{value:currentSettings?.custom_fields || this.defaultSettings.custom_fields, disabled: true},
          fields:{value:currentSettings?.fields || this.defaultSettings.fields, disabled: true},
          sort_default: {value:currentSettings?.sort_default || this.defaultSettings.sort_default,  disabled: true},
      })
    })
	}
	saveSettings() {
    let tableSettings:IUI_SettingsTable = this.tableSettings?.value as unknown as IUI_SettingsTable
    tableSettings.table_code = this.code
    let newSettings:IUI_Settings = {
      user_guid:this.user_guid,
      tables:[this.tableSettings?.value as unknown as IUI_SettingsTable]
    }
    this.uiSettingsService.setUISettings(this.user_guid,newSettings).subscribe()
		this.dialogRef.close()
	}
	get package() {return this.tableSettings?.get('package')}
	get custom_fields() {return this.tableSettings?.get('custom_fields')}
	get fields() {return this.tableSettings?.get('fields')}
	get rows_qty_to_cache() {return this.tableSettings?.get('rows_qty_to_cache')}
	get sort_default() {return this.tableSettings?.get('sort_default')}
	get page_rows_qty() {return this.tableSettings?.get('page_rows_qty')}
}
